import moment from "moment"
import janooService from "@/services/janoo/index"
import bocapioService from "@/services/cakephp/index"
import nodeService from "@/services/nodejs/index"

const bookingStoreCommit = (state, payload) => {
    state.commit(payload.mutation, payload.value)
}

const fetchDialCodes = async (state) => {
    bocapioService.getCountriesDialcode()
        .then((resp) => {
            state.commit('SET_DIAL_CODES_ARRAY', Object.values(JSON.parse(resp.countries)))
        })
}

const fetchCountries = async (state) => {
    bocapioService.getCountries()
        .then((resp) => {
            state.commit('SET_COUNTRIES_ARRAY', Object.values(JSON.parse(resp.countries)))
        })
}

const fetchStates = async (state, country) => {
    bocapioService.getUF(country)
        .then((resp) => {
            state.commit('SET_STATES_ARRAY', Object.values(JSON.parse(resp.states)))
        })
}

const fetchCities = async (state, addressState) => {
    bocapioService.getCities(addressState)
        .then((resp) => {
            var citiesJson = JSON.parse(resp.cities)
            state.commit('SET_CITIES_ARRAY', Object.entries(citiesJson))
        })
}

const fetchPlacePublicData = async (state, PLACE_UUID) => {
    state.commit('RESET_PLACE_PUBLIC_DATA')

    await bocapioService.getPublicData(PLACE_UUID)
        .then((response) => {
            state.commit('SET_PLACE_PUBLIC_DATA', response)
        })
}

const fetchTermsConditions = async (state) => {
    state.commit('RESET_TERMS_CONDITIONS')

    const JANOO_UUID = process.env.VUE_APP_UUID_JANOO

    await bocapioService.getPublicData(JANOO_UUID)
        .then((response) => {
            state.commit('SET_TERMS_CONDITIONS', response.place.term)
        })
}

const createLaterExpressBooking = (state, form) => {
    state.commit('RESET_EXPRESSBOOKING_RESPONSE')

    const FORM_COPY = {...form}

    nodeService.createGetnetQRPix(FORM_COPY)
        .then(result => {
            state.commit('SET_EXPRESSBOOKING_RESPONSE', result.data)
        })
        .catch(err => {
            console.error('ERROR >>>', err)
        })
}

const createExpressBooking = (state, form) => {
    // state.commit('RESET_MP_CALLBACK_URL_MP')
    state.commit('RESET_EXPRESSBOOKING_RESPONSE')

    const FORM_COPY = {...form}

    var description = `${FORM_COPY.atrativo.product_name} - `
    let order_total_value = 0
    let order_total_discount = 0

    const tickets = Object.values(FORM_COPY.tickets).map(function(value, index){
        if(Number(value.quantity) > 0){
            description += value.label + ': (' + value.quantity + ' x R$' + value.price + ')'
            order_total_value += Number(value.quantity) * Number(value.price.replace(",", "."))
            order_total_discount += 0

            return {
                id: value.id,
                title: value.label + ' - ' + FORM_COPY.atrativo.product_name,
                label: value.label,
                booking_name: value.booking_name,
                booking_slug: value.booking_slug,
                quantity: Number(value.quantity),
                unit_price: Number(value.price.replace(",", ".")),
                unit_discount:  Number(0),
                picture_url: FORM_COPY.atrativo.images[0],
            }
        }
    }).filter(t => t != null)

    const costumer = {
        phone: { number: FORM_COPY.phone, area_code: FORM_COPY.phoneFlag },
        name: FORM_COPY.name,
        cpf: FORM_COPY.cpf_cnpj,
        email: FORM_COPY.email
    }

    const vendor = {
       //uuid: FORM_COPY.atrativo.place_uuid, //TODO: id do place
       store_name: FORM_COPY.atrativo.product_place_name,
       phone: FORM_COPY.atrativo.vendor_number,
       email: FORM_COPY.atrativo.vendor_email,
       address:{
          street_1:"",
          street_2:"",
          city:"",
          state:"",
          zip:"",
          country:""
       }
    }

    const order = {
      ID: "",
      total_value: String(Number(order_total_value).toFixed(2)),
      total_discount: order_total_discount > 0 ? (String(Number(order_total_discount).toFixed(2))) : '0',
      final_value: String(Number(order_total_value - order_total_discount).toFixed(2))
    }

    const product = {
        id: FORM_COPY.atrativo.id,
        uuid: FORM_COPY.atrativo.uuid,
        name: FORM_COPY.atrativo.product_name,
        address: `${FORM_COPY.address.city}-${FORM_COPY.address.state}`,
        place: FORM_COPY.atrativo.product_place_name,
        product_notification_number: FORM_COPY.atrativo.notification_number,
        product_nps: FORM_COPY.atrativo.nps_link,
        groups: FORM_COPY.atrativo.nps_group,
        place_uuid: FORM_COPY.atrativo.place_uuid,
    }

    let term = {
        hash: FORM_COPY.hash,
        confirm: FORM_COPY.confirm_term,
        datetime: moment().format("YYYY-MM-DD HH:mm:ss"),
    }

    let checkins = [
    ]

    let agents = [
    ]

    let payments = [
      {
        'payment_value':'0',
        'payment_method':'cod',
        'payment_status':'PENDING',
        'payment_description':'Janoo',
        'payment_date': (new Date()).toISOString(),
        'operator_uuid':'null',
        'data_origin':{
           'payment_type':'cod',
           'order_id':'null',
           'payment_id':'null',
           'amount':'0',
           'status':'PENDING',
           'transaction_id':'null',
           'transaction_timestamp':(new Date()).toISOString(),
           'payer_name':'',
           'payer_cnpj':'',
           'payer_cpf':'',
           'receiver_psp_name':'Janoo',
           'receiver_psp_code':'0',
           'receiver_name':'Janoo',
           'receiver_cnpj':'',
           'receiver_cpf':''
        }
     }
    ]

    const defaultSaleObject = {
        //id: FORM_COPY.atrativo_id,                              // ID do atrativo
        hash: FORM_COPY.hash,                                   // Hash da reserva
        created_date: (new Date()).toISOString(),               // Data da reserva
        channel: 'RESERVAEXPRESSA',
        booking_code: "",                                       // Data da reserva
        booking_date: FORM_COPY.date + " " + FORM_COPY.time,    // Data da reserva
        description: description,                               // Descrição dos items comprados (Reserva Expressa)
        booking_slug: FORM_COPY.booking_slug,                   // Apelido de ingresso comprado
        booking_name: FORM_COPY.booking_name,                   // Nome de ingresso comprado
        vendor: vendor,
        lastStart:[],                                           // Armazena as datas antes de mudança de datas
        agents: agents,                                         // lista de agents da reserva
        checkins: checkins,                                     // lista de checkins da reserva
        costumer: costumer,                                     // Dados do comprador
        items: tickets,                                         // Ingressos
        order: order,                                           // Dados do pedido (preço total e descontos)
        product: product,                                       // Dados do atrativo
        payments: payments,
        term: term,                                             // Aceite de termos e condicoes
        payLater: FORM_COPY.payLater,                           // Pagar depois
        free_booking: FORM_COPY.free_booking,                   // Reserva Cortesia
    }

    switch (FORM_COPY.gateway) {
        case 'MPAGO':
            nodeService.postCreateExpressBookingMercadoPago(defaultSaleObject)
                .then(result => {
                    const data = result.data
                    var callback_URL = data.preference.init_point

                    if (process.env.NODE_ENV !== 'production' ) {
                        callback_URL = data.preference.sandbox_init_point
                    }

                    state.commit('SET_MP_CALLBACK_URL_MP', callback_URL)
                })
                .catch(err => {
                    console.error('ERROR >>>', err)
                })
        break

        case 'EXPRESSBOOKING':
            nodeService.createGetnetQRPix(defaultSaleObject)
                .then(result => {
                    state.commit('SET_EXPRESSBOOKING_RESPONSE', result.data)
                })
                .catch(err => {
                    console.error('ERROR >>>', err)
                })
        break

        default:
        break
    }
}

export default {
    bookingStoreCommit,
    // fetchProductsList,
    fetchPlacePublicData,
    fetchTermsConditions,
    createExpressBooking,
    createLaterExpressBooking,
    fetchDialCodes,
    fetchCountries,
    fetchStates,
    fetchCities,
}
